export default __webpack_public_path__ + "static/media/about.8eb1cc6b.svg";